var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBevnetcpgmedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550.68 192.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547.45,21.92h-28.59v87.32h-32.44V21.92h-28.12V0h89.15v21.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.54,78.23c0,8.53-2.28,15.98-8.58,22.36-6.29,6.36-13.64,8.65-22.04,8.65H0V0h59.92c8.48,0,15.85,2.29,22.11,8.63,6.25,6.33,8.52,13.81,8.52,22.39s-2.78,16.62-8.34,22.73c5.55,6.19,8.34,13.22,8.34,21.09v3.38ZM58.1,32.54c0-2.84-.87-5.51-2.95-7.63-2.08-2.11-4.69-2.99-7.48-2.99h-15.24v21.9h15.24c2.93,0,5.58-.95,7.58-3.21,2.01-2.27,2.85-5.08,2.85-8.07ZM58.1,76.22c0-2.8-.87-5.43-2.95-7.51-2.08-2.09-4.69-2.96-7.48-2.96h-15.24v21.61h15.24c2.93,0,5.58-.94,7.58-3.18,2.01-2.23,2.85-5,2.85-7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249,0c-8.37,0-11.52,7.15-12.44,11.26-1.2,5.3-11.41,48.71-11.62,49.6-.21-.9-10.43-44.31-11.62-49.6-.93-4.11-4.07-11.26-12.44-11.26h-22.82l31.42,109.24h30.95L271.82,0h-22.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.52,21.98V0h-62.91c-9.5,0-17.2,7.7-17.2,17.2v74.78c0,9.5,7.7,17.2,17.2,17.2h7.32c.16.01.32.05.48.05h55.11v-21.97h-47.67v-21.53h45.94v-21.92h-45.94v-21.84h47.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.88,21.98V0h-62.91c-9.5,0-17.2,7.7-17.2,17.2v74.78c0,9.5,7.7,17.2,17.2,17.2h7.32c.16.01.32.05.48.05h55.11v-21.97h-47.67v-21.53h45.94v-21.92h-45.94v-21.84h47.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.45,0v59.92c-4.8-9.76-24.38-49.63-25.44-51.87-1.55-3.3-5.35-8.06-13.25-8.06h-20.92v109.24h31.23v-57.77s23.09,47.24,24.28,49.78c1.55,3.31,4.86,8,13.5,8h21.85V0h-31.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.06,90.9c5.76,0,9.39,4.03,9.39,9.17s-3.63,9.17-9.3,9.17-9.3-3.99-9.3-9.12,3.72-9.21,9.21-9.21ZM538.15,106.98c4.3,0,6.82-2.92,6.82-6.91s-2.57-6.87-6.91-6.87-6.73,2.88-6.73,6.91,2.57,6.87,6.82,6.87ZM537.22,101.49v3.32h-2.61v-9.57h3.9c2.17,0,3.45,1.46,3.45,3.1,0,1.33-.75,2.26-1.51,2.61l1.77,3.85h-2.7l-1.37-3.32h-.93ZM537.22,97.46v1.9h1.06c.53,0,.97-.4.97-.97s-.44-.93-.97-.93h-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.77,178.53c-4.96,4.13-10.51,6.23-16.51,6.23-13.07,0-22.55-9.99-22.55-23.75s9.62-23.75,22.38-23.75c7.8,0,13.55,4,15.66,5.72l.84.68,2.77-7.68-.42-.34c-2.38-1.93-8.99-6.41-19.02-6.41-17.34,0-30.92,13.96-30.92,31.77s13.36,31.77,31.09,31.77c11.33,0,18.49-5.85,19.81-7.03l.38-.34-2.67-7.59-.85.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.7,130.35h-17.16v61.32h8.45v-25.03h8.72c11.14,0,18.62-7.34,18.62-18.27s-7.13-18.02-18.62-18.02ZM84.98,138.03h8.12c6.64,0,10.6,3.87,10.6,10.34s-3.96,10.6-10.6,10.6h-8.12v-20.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.1,167.59h13.33v11.47c-1.7,1.61-7.06,5.79-16.75,5.79-13.13,0-22.3-9.77-22.3-23.75s9.41-23.84,22.38-23.84c6.77,0,12.3,2.16,16.89,6.62l.55.53,5.49-5.7-.52-.53c-3.25-3.34-10.51-8.94-22.59-8.94-17.67,0-31,13.7-31,31.86s12.97,31.69,30.83,31.69c10.39,0,18.32-3.14,24.97-9.88l.22-.22v-22.69h-21.52v7.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.07 175.84 255.12 130.35 244.98 130.35 244.98 191.67 253.17 191.67 253.17 144.63 272.16 186.21 279.98 186.21 298.97 144.63 298.97 191.67 307.16 191.67 307.16 130.35 297.11 130.35 276.07 175.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "344.66 164.34 363.36 164.34 363.36 156.58 344.66 156.58 344.66 138.2 366.1 138.2 366.1 130.35 336.21 130.35 336.21 191.67 367.04 191.67 367.04 183.91 344.66 183.91 344.66 164.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.85,130.35h-13.06v61.32h13.06c21.15,0,32.8-10.89,32.8-30.66s-12.26-30.66-32.8-30.66ZM408.21,183.99h-5.98v-45.88h5.98c14.28,0,22.81,8.56,22.81,22.9s-8.31,22.98-22.81,22.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 465.28,
    y: 130.35,
    width: 8.45,
    height: 61.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.92,130.85l-.19-.5h-8.06l-22.95,61.32h8.64l7.18-19.39h22.34l7.18,19.39h8.64l-22.77-60.82ZM532.27,164.78h-17.05l8.49-23.79,8.56,23.79Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBevnetcpgmedia);
export default __webpack_public_path__ + "static/media/bevnetcpgmedia.83e0d728f1f0db1be5e4bcff52b16876.svg";
export { ForwardRef as ReactComponent };